import React from 'react';
import { AtomIcon, HeartHandshakeIcon, MonitorOffIcon, SparklesIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { benefits } from '../data/content';
const ICONS = {
  screenOff: MonitorOffIcon,
  atom: AtomIcon,
  sparkles: SparklesIcon,
  family: HeartHandshakeIcon
};
const ICON_COLORS = ['bg-brand-orange', 'bg-brand-green', 'bg-brand-yellow', 'bg-brand-gold'];
export function BenefitsSection() {
  return <section aria-labelledby="beneficios" className="bg-brand-blue" data-id="element-16" data-mp="38qpijph87glb">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-17" data-mp="3ds6er7ormevk">
        <h2 id="beneficios" className="font-display text-[1.75rem] leading-[1.05] text-white sm:text-5xl" data-id="element-18" data-mp="2zrvpua70nad1">
          ¿Qué puede cambiar cuando empiezan?
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white" data-id="element-19" data-mp="y08wi1znj3de">
          Un proyecto creativo puede despertar nuevas habilidades y grandes
          descubrimientos.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-20" data-mp="2bexjl2jrwmso">
          {benefits.map((benefit, i) => {
          const Icon = ICONS[benefit.icon];
          return <Reveal key={benefit.title} as="li" delay={i * 0.03} className="flex h-full gap-2.5 rounded-xl border-2 border-brand-navy bg-white p-2.5 text-left" data-id="element-21" data-mp="27bhqgg6wx4kq" data-mpi={i}>
                <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg ${ICON_COLORS[i]}`} data-id="element-22" data-mp="1sfs065up25a7">
                  <Icon size={16} className="text-brand-navy" data-id="element-23" data-mp="1ogszixfzwuok" />
                </span>
                <div data-id="element-24" data-mp="22fsn01rrv3j5">
                  <h3 className="font-sub text-sm font-bold leading-tight text-brand-blue" data-id="element-25" data-mp="22c4th2mbuh4f">
                    {benefit.title}
                  </h3>
                  <p className="mt-0.5 text-xs leading-snug text-brand-muted sm:text-sm" data-id="element-26" data-mp="3dsldl98ttlxm">
                    {benefit.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ul>
      </div>
    </section>;
}